import { useImperativeHandle, forwardRef, useState, useEffect } from "react";

type MySelectProps = {
  options: [string, string][];
  defaultValue?: string;
  name?: string;
  onChange?: (event: {
    target: { value: string; name: string };
    type: string;
  }) => void;
};

// Type for the ref object that react-hook-form expects
type SelectRef = {
  value: string;
  name?: string;
};

const MySelect = forwardRef<SelectRef, MySelectProps>(
  ({ options, defaultValue = "", name, onChange }, ref) => {
    const [value, setValue] = useState(defaultValue);

    // Update value when defaultValue changes
    useEffect(() => {
      setValue(defaultValue);
    }, [defaultValue]);

    useImperativeHandle(ref, () => ({
      value,
      name: name || "", // optional for RHF registration
    }));

    const handleChange = (newVal: string) => {
      setValue(newVal);
      // Call the onChange function from react-hook-form with a synthetic event
      if (onChange) {
        // Create a synthetic event object that react-hook-form expects
        const syntheticEvent = {
          target: {
            value: newVal,
            name: name || "",
          },
          type: "change",
        };
        onChange(syntheticEvent);
      }
    };

    return (
      <div className="mt-4">
        <div className="flex flex-wrap gap-2">
          {options.map(([val, label]) => (
            <button
              key={val}
              type="button"
              onClick={() => handleChange(val)}
              className={`px-3 py-1 rounded-full border text-sm ${
                value === val
                  ? "bg-blue-600 text-white border-blue-600"
                  : "bg-white text-gray-700 border-gray-300"
              }`}
            >
              {label}
            </button>
          ))}
        </div>
      </div>
    );
  },
);

export default MySelect;
